import type { LbOptions } from '@uefacom-newdev/liveblog-integration-react';

import type { DrawOptions } from '@apps/draw/store/types';
import type { VideoPlayerOptions } from '@apps/videoplayer/app';

export enum DrawTabId {
  RESULTS = 'RESULTS',
  UPDATES = 'UPDATES',
  POTS = 'POTS',
  PROCEDURE = 'PROCEDURE',
}

type anotherVideoSourceOptions = {
  anotherSource?: boolean;
  videoOtherSource?: string;
  videoOtherSourceText?: string;
};

export type DrawCentreOptions = DrawOptions & {
  isDrawArticleAvailable?: boolean;
  liveblogOptions?: LbOptions;
  defaultVideoPlayerOptions?: VideoPlayerOptions;
  videoObjectAvailable?: boolean;
  videoObjectOptions?: VideoPlayerOptions;
  anotherSourceOptions?: anotherVideoSourceOptions;
  pageName?: string;
  videoPromoLibrary?: string;
};

export type TabsState = {
  tab?: DrawTabId;
  setTab: (mode?: DrawTabId) => void;
};

export type VideoHeightState = {
  videoHeight?: number;
  setVideoHeight: (videoHeight?: number) => void;
};

export type DrawCentreState = TabsState & VideoHeightState;
